import { Component } from '@angular/core';
import { ProjectProgressLogParams } from '../project-progress-log.component';
import { StateService } from '@app/core/services/state.service';

@Component({
    selector: 'tt-project-progress-log-view',
    templateUrl: './project-progress-log-view.component.html',
    styleUrls: ['./project-progress-log-view.component.css'],
})
export class ProjectProgressLogViewComponent {
    public params?: ProjectProgressLogParams;

    constructor(private state: StateService) {
        this.params = state.getStateParams() as unknown as ProjectProgressLogParams;
    }
}
